var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, css, html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { localized, msg } from '@lit/localize';
let CreateWorkflowModal = class CreateWorkflowModal extends LitElement {
    constructor() {
        super(...arguments);
        this.name = '';
        this.description = '';
    }
    handleNameChange(e) {
        const input = e.detail;
        this.name = input;
    }
    handleDescriptionChange(e) {
        const input = e.detail;
        this.description = input;
    }
    handleSubmit() {
        this.dispatchEvent(new CustomEvent('create-workflow', {
            detail: {
                name: this.name,
                description: this.description,
                is_active: false,
                properties: {}
            },
            bubbles: true,
            composed: true,
        }));
    }
    render() {
        return html `
            <form-modal title=${msg('Create New Workflow', { id: 'workflow.create.title', desc: 'Create workflow modal title' })}>
                <div class="form-content">
                    <div>
                        <label for="workflow-name">${msg('Workflow Name')}</label>
                        <input-text placeholder="${msg('Enter workflow name')}" id="workflow-name" class="input" @input-text="${this.handleNameChange}"></input-text>
                    </div>
                    <div>
                        <label for="workflow-description">${msg('Description')}</label>
                        <input-text-area placeholder="${msg('Enter description')}" id="workflow-description" class="input" @input-text-area="${this.handleDescriptionChange}"></input-text-area>
                    </div>
                </div>
                <div class="button-row">
                    <simple-button variant="primary" @button-click="${this.handleSubmit}" label="${msg('Create')}"></simple-button>
                </div>
            </form-modal>
        `;
    }
};
CreateWorkflowModal.styles = css `
        :host {
            display: block;
        }
        .form-content {
            display: flex;
            flex-direction: column;
            gap: 1rem;
        }
        .button-row {
            display: flex;
            justify-content: flex-end;
            margin-top: 1.5rem;
        }
    `;
CreateWorkflowModal = __decorate([
    localized(),
    customElement('create-workflow-modal')
], CreateWorkflowModal);
export { CreateWorkflowModal };
//# sourceMappingURL=CreateWorkflowModal.js.map